var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"date white--text",staticStyle:{"padding-left":"5px","padding-right":"5px"}},[_vm._v(_vm._s(_vm.digitalClock.date)+" "+_vm._s(_vm.digitalClock.time))])
}
var staticRenderFns = []

export { render, staticRenderFns }